import { styleTags, tags as t } from '@lezer/highlight';

export const multipartHighlighting = styleTags({
  // Boundary markers - keyword style (red/pink)
  Boundary: t.keyword,
  BoundaryLine: t.keyword,

  // Header names - property name style (purple)
  ContentDispositionName: t.propertyName,
  ContentTypeName: t.propertyName,
  PartHeaderName: t.propertyName,

  // form-data keyword - like HTTP methods
  FormData: t.keyword,

  // Attribute names and values (name="file", filename="doc.pdf")
  AttributeName: t.attributeName,
  AttributeValue: t.string,

  // Header values
  contentTypeValue: t.attributeValue,
  partHeaderValue: t.attributeValue,

  // Body content
  BodyContent: t.content,
  bodyLine: t.content,
});
